<template>
  <v-dialog v-model="modal" :width="modalSize">
    <v-bottom-navigation height="100px">
      <v-btn @click="openRadiant" v-if="radiantActive">
        <img src="resources/images/radiant.svg" height="75px" />
      </v-btn>
      <v-btn @click="openHoros" v-if="horosActive">
        <img src="resources/images/horos.png" height="75px" />
      </v-btn>
      <v-btn @click="openWeasis" v-if="weasisActive">
        <img src="resources/images/weasis.svg" height="75px" />
      </v-btn>
      <v-btn @click="openOrthanc" v-if="orthancActive">
        <img src="resources/images/orthanc.png" height="75px" />
      </v-btn>
      <v-btn @click="openOhif" v-if="ohifActive">
        <img src="resources/images/ohif.svg" height="75px" />
      </v-btn>
    </v-bottom-navigation>
  </v-dialog>
</template>

<script>
export default {
  name: "ViewModal",
  props: {
    studyData: Object,
    dicomViewers: Object,
  },
  computed: {
    radiantActive: function () {
      if (this.dicomViewers == null || this.dicomViewers.viewers == null) {
        return false;
      } else if (navigator.platform.indexOf("Win") > -1) {
        return this.dicomViewers.viewers.radiantActive;
      } else if (navigator.platform.indexOf("Linux") > -1) {
        return this.dicomViewers.viewers.radiantActive;
      } else {
        return false;
      }
    },
    weasisActive: function () {
      if (this.dicomViewers == null || this.dicomViewers.viewers == null) {
        return false;
      } else {
        return this.dicomViewers.viewers.weasisActive;
      }
    },
    orthancActive: function () {
      if (this.dicomViewers == null || this.dicomViewers.viewers == null) {
        return false;
      } else {
        return this.dicomViewers.viewers.orthancActive;
      }
    },
    ohifActive: function () {
      if (this.dicomViewers == null || this.dicomViewers.viewers == null) {
        return false;
      } else {
        return this.dicomViewers.viewers.ohifActive;
      }
    },
    horosActive: function () {
      if (this.dicomViewers == null || this.dicomViewers.viewers == null) {
        return false;
      } else if (navigator.platform.indexOf("Mac") > -1) {
        return this.dicomViewers.viewers.horosActive;
      } else {
        return false;
      }
    },
    modalSize: function () {
      let size = 0;
      const WIDTH = 105;
      const isMac = navigator.platform.indexOf("Mac") > -1;
      const isLinux = navigator.platform.indexOf("Linux") > -1;
      const isWin = navigator.platform.indexOf("Win") > -1;

      if (
        this.dicomViewers != null &&
        this.dicomViewers.viewers.radiantActive &&
        (isLinux || isWin)
      )
        size += WIDTH;
      if (this.dicomViewers != null && this.dicomViewers.viewers.weasisActive)
        size += WIDTH;
      if (this.dicomViewers != null && this.dicomViewers.viewers.orthancActive)
        size += WIDTH;
      if (this.dicomViewers != null && this.dicomViewers.viewers.ohifActive)
        size += WIDTH;
      if (
        this.dicomViewers != null &&
        this.dicomViewers.viewers.horosActive &&
        isMac
      )
        size += WIDTH;
      return size;
    },
  },
  data: () => ({
    modal: false,
    study: "",
    aeTitle: "PROTEUS",
    link: null,
  }),
  watch: {
    studyData: function (value) {
      this.study = value.data;
      this.modal = true;
    },
    modal: function (value) {
      if (this.link && !value) {
        // Wait for modal to hide
        setTimeout(() => {
          window.open(this.link);
          this.link = null;
        }, 200);
      }
    },
  },
  methods: {
    isMac() {
      console.log(navigator.platform);
      return navigator.platform.indexOf("Mac") > -1;
    },
    openRadiant() {
      this.link =
        "radiant://?n=paet&v=" +
        this.dicomViewers.aeTitle +
        "&n=pstv&v=0020000D&v=%22" +
        this.study.studyIuid +
        "%22";
      this.modal = false;
    },
    openOhif() {
      let studyIuid = this.study.studyIuid;

      // Fix OHIF error
      if (studyIuid.indexOf(".") === -1) {
        studyIuid += "..";
      }
      this.link = "/viewer/" + studyIuid;
      this.modal = false;
    },
    openWeasis() {
      let url =
        '$dicom:rs --url "' +
        window.location.href +
        'api/v1/dicom-web" -r "studyUID=' +
        this.study.studyIuid +
        '"';
      this.link = "weasis://" + encodeURI(url);
      this.modal = false;
    },
    openOrthanc() {
      this.link =
        this.dicomViewers.viewers.orthancUrl +
        "/index.html?study=" +
        this.study.studyIuid;
      this.modal = false;
    },
    openHoros() {
      this.link =
        "osirix://?methodName=retrieve&serverName=" +
        this.dicomViewers.aeTitle +
        "&filterKey=StudyInstanceUID&filterValue=" +
        this.study.studyIuid;
      this.modal = false;
    },
  },
};
</script>

<style scoped>
.v-dialog {
  bottom: 10px !important;
  right: 0 !important;
}
</style>
